import { useQuery } from "@apollo/client";
import { GetCustomerQueryVariables, GetCustomersQuery } from "_graphql/queries/__generated__/graphql";
import { getCustomers } from "_graphql/queries/customers";

const useGetCustomers = (id: string) => {
    const { data, loading, error } = useQuery<
    GetCustomersQuery,
    GetCustomerQueryVariables
  >(getCustomers, {
    variables: {
      filter: {
        user_id: {
          eq: id,
        },
      },
    },
  });
  return { data, loading, error };
};

export default useGetCustomers;